<template>
  <div class="chart_dialog" ref="dialog" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tabList">
      <div class="tabItem"
           v-for="(item, index) in tabList"
           @click="handleChange(index)"
          :class="{ active: active === index }"
          :key="'t' + index">{{item.label}}</div>
    </div>
    <div class="content">
      <el-date-picker
        v-show="!isDaily"
        :clearable = "false"
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="picker">
      </el-date-picker>
     <div v-if="[0, 1, 2].includes(active)" ref="chart" class="chart"></div>
     <div v-if="[1, 2].includes(active)" ref="chart1" class="chart1"></div>
     <div v-if="isDaily" class="word">
      <div class="tool">
        <i @click="onLoad" class="iconfont icon-xiazai" v-show="$ButtonShow('addDaily')"></i>
        <i @click="onDetail" class="iconfont icon-chakan" v-show="$ButtonShow('detailDaily')"></i>
      </div>
      <div class="list infinite-list-wrapper">
        <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
          <div v-for="(item, index) in list" class="item"
              :class="{ active: textIndex === index }" :key="index" @click="onClick(index, item)">
            <img src="../../assets/img/statement/word.png">
            <span>{{item.dailyDate}}</span>
          </div>
        </ul>
        <p class="tip" v-if="loading">加载中...</p>
        <p class="tip" v-if="noMore">{{list.length ? '没有更多了' : '暂无数据'}}</p>
      </div>
     </div>
    </div>

    <el-dialog :title="title" :visible.sync="showDialog" width='1200px' class="dialog" :close-on-click-modal='false' destroy-on-close>
      <Daily ref="daily" :dailyId = "dailyId"></Daily>
    </el-dialog>
 </div>
 </template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
import Daily from './Daily'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: 'ChartDialog',
  components: {
    Daily
  },
  data () {
    return {
      active: 0,
      dateRange: [],
      tabList: [{
        label: '劳务'
      }, {
        label: '机械'
      }, {
        label: '物料'
      }, {
        label: '日报'
      }],
      list: [],
      textIndex: -1,
      showDialog: false,
      dailyId: '',
      title: '',
      fullscreenLoading: false,
      noMore: false,
      loading: false,
      page: 1,
      size: 12
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    },
    theme () {
      return this.$store.state.theme
    },
    isDaily () {
      return this.active === 3
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  watch: {
    projectId () {
      this.handleChange(this.active)
    },
    theme () {
      this.setTheme()
    },
    dateRange () {
      this.loadData()
    }
  },
  created () {
    this.chart = null
    this.chart1 = null
    this._requestMap = new Map()
    this._requestMap.set(0, this.$apis.statement.selectJgWorkerSum)
    this._requestMap.set(1, this.$apis.statement.selecJgMachinerySum)
    this._requestMap.set(2, this.$apis.statement.selecJgMaterialSum)
    this.loadData()
  },
  destroyed () {
    this.chart && this.chart.dispose()
    this.chart1 && this.chart1.dispose()
  },
  methods: {
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      this.dateRange = [vals, val]
    },
    handleChange (tabIndex) {
      this.active = tabIndex
      if (this.active < 3) {
        this.loadData()
      } else {
        this.page = 1
        this.list = []
        this.chart && this.chart.dispose()
        this.chart1 && this.chart1.dispose()
        this.load()
      }
    },
    load () {
      this.$axios.get(this.$apis.statement.selectYhProjectDailyByPage, {
        projectId: this.projectId,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.page++
        this.list = res && res.list.length > 0 ? this.list.concat(res.list) : this.list
        this.noMore = this.list.length >= res.total
      }).finally(() => {
        this.loading = false
      }).catch(() => {
        this.noMore = true
      })
    },
    clearEchart () {
      this.chart && this.chart.clear()
      this.chart1 && this.chart1.clear()
    },
    loadData () {
      this.$axios.get(this._requestMap.get(this.active), {
        projectId: this.projectId,
        startTime: this.dateRange[0],
        endTime: this.dateRange[1]
      }).then(res => {
        this.clearEchart()
        const color = ['#45DB5E', '#1C62F3', '#0BBCEF', '#68BBC4', '#58A55C', '#5087EC']
        if (this.active === 0) {
          this.renderChart([
            {
              name: '专职人员',
              value: res.singleSignCount || 0
            },
            {
              name: '劳务班组',
              value: res.teamSignCount || 0
            }],
          color, {
            name: '总出勤人数',
            per: res.signCount
          }, 'chart')
        }
        // 机械
        if (this.active === 1) {
          // res = {
          //   count: 10,
          //   countMap: {
          //     机械1: 10
          //   },
          //   amount: 1000,
          //   amountMap: {
          //     机械1: 10
          //   }
          // }
          this.renderChart(this.handelData(res.countMap),
            color, {
              name: '总台班数',
              per: res.count
            }, 'chart')
          this.renderChart(this.handelData(res.amountMap), color, {
            name: '总金额(元)',
            per: res.amount
          }, 'chart1')
        }
        // 物料
        if (this.active === 2) {
          // res = {
          //   inAmount: 10,
          //   inMap: {
          //     机械1: 10,
          //     机械4: 40
          //   },
          //   outAmount: 1000,
          //   outMap: {
          //     机械1: 10
          //   }
          // }
          this.renderChart(this.handelData(res.inMap),
            color, {
              name: '出库金额(元)',
              per: res.outAmount
            }, 'chart')
          this.renderChart(this.handelData(res.outMap), color, {
            name: '入库金额(元)',
            per: res.inAmount
          }, 'chart1')
        }
      })
    },
    handelData (res) {
      const data = []
      for (const key in res) {
        data.push({
          name: key,
          value: res[key]
        })
      }
      return data
    },
    renderChart (data, color, title, ref) {
      this.$nextTick(() => {
        this[ref] = echarts.init(this.$refs[ref])
        const option = {
          tooltip: {
            show: false,
            formatter: '{a} <br/>{b}: {d}%',
            textStyle: {
              fontSize: px2vw(12)
            }
          },
          title: {
            show: title.name,
            text: title.per,
            subtext: title.name,
            left: '48%',
            textAlign: 'center',
            top: '40%',
            textStyle: {
              color: '#000000',
              fontSize: px2vw(12),
              fontFamily: 'PingFangSC, PingFang SC'
            },
            subtextStyle: {
              color: '#000000',
              fontSize: px2vw(12),
              lineHeight: 0,
              fontFamily: 'PingFangSC, PingFang SC'
            }
          },
          legend: {
            show: false
          },
          color: color,
          series: [
            {
              type: 'pie',
              radius: ['35%', '50%'],
              center: ['50%', '50%'],
              startAngle: 0,
              labelLine: {
                show: true,
                showAbove: true,
                length: px2vw(10),
                length2: px2vw(30),
                lineStyle: {
                  color: '#8098CD'
                },
                maxSurfaceAngle: px2vw(80)
              },
              label: {
                fontSize: px2vw(14),
                show: true,
                formatter: '{b}\n{c}',
                color: '#000000',
                position: 'outside',
                edgeDistance: '50%',
                lineHeight: px2vw(20),
                padding: [0, -px2vw(20), 0, -px2vw(20)],
                bleedMargin: 10,
                alignTo: 'labelLine'
              },
              // itemStyle: {
              //   normal: {
              //     borderColor: 'rgba(0, 0, 0, 1)',
              //     borderWidth: 0,
              //     color: (value) => {
              //       return color[value.dataIndex]
              //     }
              //   }
              // },
              data: data
            },
            {
              labelLine: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                    offset: 0,
                    color: '#C2DBEF'
                  }, {
                    offset: 1,
                    color: '#C4D1EF'
                  }])
                }
              },
              type: 'pie',
              hoverAnimation: false,
              radius: ['30%', '56%'],
              center: ['50%', '50%'],
              label: {
                normal: {
                  show: false
                }
              },
              data: [100],
              zlevel: -1
            }
          ]
        }
        setTimeout(() => {
          this[ref].setOption(option)
          this.setTheme()
        })
      })
    },
    onClick (index, item) {
      this.textIndex = index
      this.dailyId = item.dailyId
      this.title = item.dailyDate + '日报'
    },
    setTheme () {
      const style = window.getComputedStyle(this.$refs.dialog)
      const color = style.getPropertyValue('--header-bar-title-color').trim()
      const option = {
        title: {
          textStyle: {
            color: color
          },
          subtextStyle: {
            color: color
          }
        },
        legend: {
          textStyle: {
            color: color
          }
        },
        series: {
          type: 'pie',
          label: {
            color: color
          }
        }
      }
      this.chart && this.chart.setOption(option)
      this.chart1 && this.chart1.setOption(option)
    },
    onLoad () {
      if (this.dailyId) {
        this.fullscreenLoading = true
        this.showDialog = true
        setTimeout(() => {
          const element = this.$refs.daily.$el
          console.log(element)
          html2canvas(element).then((canvas) => {
            console.log(canvas)
            const imgData = canvas.toDataURL('image/png')
            // 计算 PDF 页面尺寸
            const pdfWidth = canvas.width * 0.264583 // 1像素=0.264583mm
            const pdfHeight = canvas.height * 0.264583
            const pdf = new JsPDF('p', 'mm', [pdfWidth, pdfHeight])
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
            pdf.save(this.title)
            this.showDialog = false
            this.fullscreenLoading = false
          })
        }, 2000)
      } else {
        this.$message.warning('请选择日报！')
      }
    },
    onDetail () {
      // 1
      if (this.dailyId) {
        this.showDialog = true
      } else {
        this.$message.warning('请选择日报！')
      }
    }
  }
}
</script>

 <style scoped lang='scss'>
 .chart_dialog{
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: var(--font-color) !important;

  .tabList {
    display: flex;
    width: 100%;
    padding: 1px 6px 0;
    background: var(--right-bg-tab);
    overflow: auto;
    .tabItem {
      flex-shrink: 0;
      position: relative;
      font-family: PingFang SC;
      font-size: 12px;
      height: 26px;
      line-height: 26px;
      padding: 0 11px 0 7px !important;
      cursor: pointer;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0px;
        width: 4px;
        height: 100%;
        background: var(--right-bg-tab);
      }
      &.active {
        position: relative;
        padding-right: 11px !important;
        background: var(--right-bg-tab-active);
        &::after {
          right: -4px;
          width: 8px;
          background: var(--right-bg-tab);
          transform: skewX(8deg);
        }
      }
    }
  }
  .content{
    background: var(--right-bg-content);
    box-shadow: 0px 1px 0px 0px var(--right-shadow-content);
    border: 1px solid var(--right-border-content);
    margin: 4px;

    ::v-deep {
      .el-date-editor{
        width: 293px !important;
        height: 30px !important;
        border-radius: 10px !important;
        margin: 10px !important;
      }
    }
    .chart,.chart1{
      height: 180px;
      margin: 0px 19px;
    }
    .tool{
      display: flex;
      align-items: center;
      height: 20px;
      padding-left: 10px;
      border-top: 1px solid var(--right-border-content);
      border-bottom: 1px solid var(--right-border-content);
      margin-bottom: 2px;
      i {
        font-size: 8px;
        cursor: pointer;
        margin-right: 10px;
      }
    }
    .list{
      width: 100%;
      padding: 0 12px;
      // max-height: 200px;
      height: 240px;
      overflow: auto;
      .infinite-list {
        // display: flex;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: center;
        margin-top: 2px;
        cursor: pointer;
        .item{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 72px;
          height: 77px;
          padding: 14px 0px 10px;
          cursor: pointer;
          &.active{
            background: #BFBFBF;
            border: 1px solid #A8A8A8;
          }
          .name{
            display: block;
            width: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        img{
          width: 32px;
          height: 34px;
        }
      }
      .tip {
        width: 100%;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        padding: 10px 5px;
      }
      // .item{
      //   display: flex;
      //   flex-direction: column;
      //   align-items: center;
      //   width: 72px;
      //   height: 77px;
      //   padding: 14px 0px 10px;
      //   cursor: pointer;
      //   &.active{
      //     background: #BFBFBF;
      //     border: 1px solid #A8A8A8;
      //   }
      // }
      img{
        width: 32px;
        height: 34px;
        margin-bottom: 9px;
      }
    }
  }
 }
::v-deep .el-dialog__body {
  height: 600px;
  overflow: auto;
  color: #000000 !important;
  background: #ffffff !important;
  // .el-table{
  //   color: var(--font-color) !important;
  //   tr, th{
  //     background-color: var(--form-bg-color) !important;
  //     border-bottom: 1px solid var(--right-border-content) !important; /* 表头底部边框 */
  //   }
  // }
}

// ::v-deep {
//   .custom-table-border {
//     border: 1px solid var(--right-border-content) !important; /* 红色边框 */
//     border-collapse: collapse;
//   }

//   .custom-table-border .el-table__row {
//     border-bottom: 1px solid var(--right-border-content) !important; /* 行的底部边框 */
//   }

//   .custom-table-border .el-table__cell {
//     border-right: 1px solid var(--right-border-content); /* 单元格的右边边框 */
//   }

//   // .custom-table-border .el-table__cell:last-child {
//   //   border-right: none !important; /* 最右边单元格的边框 */
//   // }

//   .custom-table-border .el-table__header-wrapper tr {
//     border-bottom: 1px solid var(--right-border-content) !important; /* 表头底部边框 */
//   }
// }
.buttonList {
  width: 100%;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  margin-bottom: 2px;
  .iconfont {
    font-size: 10px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.tip {
    width: 100%;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    padding: 10px 5px;
  }
 </style>
